module.exports = __webpack_public_path__ + "assets/images/95d728f7ba3efe0b75509ed6b740c04e.svg";